module.exports = __webpack_public_path__ + "static/media/obestinado_o.673ead8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/obestinado_o.png
// module id = 1147
// module chunks = 0